import React from "react";
import { Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from "@chakra-ui/react";
import { detectFileType } from "./certificationUtils";

/**
 * Renders either an image or a PDF iframe based on the file type.
 * @param {Object} props
 * @param {string} props.url - URL of the file to display
 * @returns {React.ReactElement}
 */
function ImageOrPdfPreview({ url }) {
    if (detectFileType(url) === "image") {
        return <Image src={url} alt="Agrandissement" w="100%" h="auto" display="block" borderRadius="12px" />;
    }
    return <iframe src={url} title="Aperçu du document" style={{ width: "100%", height: "80vh", border: "none" }} />;
}

/**
 * Full-screen dialog for viewing images or PDFs from certification documents.
 * @param {Object} props
 * @param {boolean} props.open - Whether the dialog is visible
 * @param {Function} props.onClose - Callback to close the dialog
 * @param {string|null} props.imageUrl - URL of the image or PDF to display
 * @returns {React.ReactElement}
 */
function ImageViewerDialog({ open, onClose, imageUrl }) {
    return (
        <Modal isOpen={open} onClose={onClose} size="4xl" isCentered scrollBehavior="inside">
            <ModalOverlay />
            <ModalContent>
                <ModalCloseButton zIndex="1" />
                <ModalBody p="0" position="relative">
                    {imageUrl && <ImageOrPdfPreview url={imageUrl} />}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

export default ImageViewerDialog;
